(() => {
  const SELECTOR = '[data-fall-sale-upgrade]';

  function initializeFallSaleUpgrade(block) {
    if (!block || block.dataset.fallSaleInitialized === 'true') return;

    block.dataset.fallSaleInitialized = 'true';

    const radios = block.querySelectorAll('[data-fall-sale-variant]');
    const clearButton = block.querySelector('[data-fall-sale-clear]');
    const checkoutNote = block.querySelector('[data-fall-sale-checkout-note]');

    const productInfo = block.closest('product-info');
    const productForm = productInfo?.querySelector('product-form');
    const paymentButton = productForm?.querySelector('.shopify-payment-button');

    if (!radios.length) return;

    function getSelectedRadio() {
      return block.querySelector('[data-fall-sale-variant]:checked');
    }

    function updateInterface() {
      const selectedRadio = getSelectedRadio();
      const hasSelection = Boolean(selectedRadio);

      if (clearButton) {
        clearButton.hidden = !hasSelection;
      }

      if (checkoutNote) {
        checkoutNote.hidden = !hasSelection;
      }

      if (paymentButton) {
        paymentButton.hidden = hasSelection;
      }

      if (hasSelection) {
        block.dataset.selectedPromotionVariant = selectedRadio.value;
        block.dataset.selectedPromotionVariantTitle =
          selectedRadio.dataset.variantTitle || '';
      } else {
        delete block.dataset.selectedPromotionVariant;
        delete block.dataset.selectedPromotionVariantTitle;
      }
    }

    radios.forEach((radio) => {
      radio.addEventListener('change', updateInterface);
    });

    if (clearButton) {
      clearButton.addEventListener('click', () => {
        radios.forEach((radio) => {
          radio.checked = false;
        });

        updateInterface();
      });
    }

    updateInterface();
  }

  function initializeAllFallSaleUpgrades(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initializeFallSaleUpgrade);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAllFallSaleUpgrades();
    });
  } else {
    initializeAllFallSaleUpgrades();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllFallSaleUpgrades(event.target);
  });
})();